import { render } from "./measurements.vue?vue&type=template&id=382c431f"
import script from "./measurements.vue?vue&type=script&lang=js"
export * from "./measurements.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__